import Vue from 'vue'
import Vuex from 'vuex'
import Api from './modules/Api'

Vue.use(Vuex);

const INITIAL_STATE = {
  appVersion: process.env.VUE_APP_VERSION,
  appMode: 'website',
  
  baseUrl: process.env.VUE_APP_API_BASE,
  apiVersion: null,
  
  authToken: null,
  user: null,
  
  waitForFetch: false,
  catalogueScrollY: 0,
  
  // language: 'en',
  // localizations: {},
  
  filter: {
    query: '',
    brand: '',
    material: '',
    engine: '',
    region: '',
    minLength: '',
    maxLength: '',
    business_case: '',
  },
  
  /* @deprecated => */
  fetchPending: false,
  
  converters: [],
  converterPage: 1,
  
  currencies: [],
  regions: [],
  brands: [],
  materials: [],
  engines: [],
  
  latestError: {
    code: 418,
    message: 'I\'m a teapot',
    hidden: true
  },
  
  hideAccessForm: false,
}

export default new Vuex.Store({
	state: {
    ...INITIAL_STATE
	},
	getters: {},
	mutations: {
		setCatalogueScrollY: (state, catalogueScrollY) => state.catalogueScrollY = catalogueScrollY,
		
		setFilter: (state, filter) => state.filter = filter,
		setWaitForFetch: (state, waitForFetch) => state.waitForFetch = waitForFetch,
		
		// TODO: prüfen ob noch gebraucht =>
		setBaseUrl: (state, url) => state.baseUrl = url,
		setAppMode: (state, mode) => state.appMode = mode,
		setApiVersion: (state, version) => state.apiVersion = version,
		setPendingState: (state, isPending) => state.fetchPending = isPending,
		
		setLatestError: (state, e) => state.latestError = e,
		hideLatestError: (state, e) => state.latestError.hidden = e,
		hideAccessForm: (state, e) => {
			state.hideAccessForm = e
			sessionStorage.setItem('hideAccessForm', e);
		},
	},
	actions: {},
	modules: {
		Api
	}
})
